// Module
var code = "<!--ko if: _isReady--> <div class=\"guest-page\"> <!--ko if: _imageData--> <img class=\"guest-page__img\" data-bind=\"attr: {src: _imageData}\"> <!--/ko--> <!--ko ifnot: _imageData--> <!--ko template: {html: GetIFrame}--><!--/ko--> <!--/ko--> </div> <!--/ko-->";
// Exports
export default code;